import React from 'react';

import { ColumnsGrid, ContentGrid } from '../components/columnsGrid';
import ContentSection from '../components/contentSection';
import Text from '../components/text';

export default data => (
  <ContentSection>
    <ColumnsGrid>
      <ContentGrid>
        <Text content={data.text} type="single" />
      </ContentGrid>
    </ColumnsGrid>
  </ContentSection>
)
